import { axiosInstance } from "../axios";

export const nguyenVatLieuApi = {
  getAll: async (params) => {
    return await axiosInstance.get("/materials", { params });
  },
  getByCode: async (code) => {
    return await axiosInstance.get(`/materials/getByCode/${code}`);
  },
  update: async (body) => {
    return await axiosInstance.post("/materials/update", body);
  },
  remove: async (code) => {
    return await axiosInstance.post("/materials/delete", { code });
  },
  vendorCreate: async (body) => {
    return await axiosInstance.post("/materials/supplier", body);
  },
  vendorDelete: async (id) => {
    return await axiosInstance.delete(`/materials/supplier/${id}`);
  },
  updatePrice: async (code, body) => {
    return await axiosInstance.put(`/materials/price-adjustment/${code}`, body);
  },
  getPriceUpdateReports: async (params) => {
    return await axiosInstance.get("/materials/price-adjustment", { params });
  },
  exportPriceReport: async (params) => {
    return await axiosInstance.get("/materials/price-adjustment/export", {
      params,
      responseType: "blob",
    });
  },
  getMyMaterials: async (store_code) => {
    return await axiosInstance.get(`/materials/my-materials/${store_code}`);
  },
  getAllUncheckMaterials: async (params) => {
    return await axiosInstance.get("/inventory-check/getMaterial", { params });
  },
};
